import { useEffect, useState } from 'react';
import { fetchLiveCalls } from '../services/api';

export const LIVE_CALLS_REFRESH_MS = 2000;

const INITIAL = { outgoing: null, incoming: null, available: false, partial: false, error: false };

// Outgoing / incoming calls happening right now. Polls while the page is
// open, skips polling while the browser tab is hidden, never has two
// requests in flight, and fetches straight away when the tab comes back.
const useLiveCalls = (intervalMs = LIVE_CALLS_REFRESH_MS) => {
  const [live, setLive] = useState(INITIAL);

  useEffect(() => {
    let cancelled = false;
    let inFlight = false;

    const load = async () => {
      if (inFlight || document.hidden) {
        return;
      }
      inFlight = true;
      try {
        const data = await fetchLiveCalls();
        if (!cancelled) {
          setLive({
            outgoing: data.outgoing,
            incoming: data.incoming,
            available: Boolean(data.available),
            partial: Boolean(data.partial),
            error: false,
          });
        }
      } catch (error) {
        if (!cancelled) {
          // Never show a number we could not confirm.
          setLive({ ...INITIAL, error: true });
        }
      } finally {
        inFlight = false;
      }
    };

    const onVisible = () => {
      if (!document.hidden) {
        load();
      }
    };

    load();
    const timer = setInterval(load, intervalMs);
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs]);

  return live;
};

export default useLiveCalls;
